import axios from 'axios'

const billingServices = {
  getInvoiceTransactions: ({ storeId, invoiceId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/billing/invoices/${invoiceId}/transactions`, {
      params: { ...params },
    }),
  getInvoiceDetail: ({ storeId, invoiceId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/billing/invoices/${invoiceId}`),
  getBillingReports: ({ storeId, returnPortalId, params }) =>
    axios.get(
      `${import.meta.env.VITE_HOST}/stores/${storeId}/billing/invoices?${
        params
          ? params?.status
              .filter(status => status !== 'delayed' && status !== 'processed')
              .map(p => `status=${p}`)
              .join('&')
          : ''
      }`,
      {
        params: { ...params, status: [], portal_id: returnPortalId },
      }
    ),
  getBillingBalance: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/billing/balance`),
}

export default billingServices
